var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 306,
    height: 333.107,
    viewBox: "0 0 306 333.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(-268.948 -185.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(5.672 -132.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 153,
    cy: 153,
    r: 153,
    transform: "translate(263.276 317.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M2.681,9.8l-.018,0L0,0,6.181.895A4.482,4.482,0,0,1,8.253.38a4.758,4.758,0,0,1,3.169,1.274l2.561.371V8.106h0c-.035,4.178-2.587,7.552-5.73,7.552C5.548,15.658,3.281,13.158,2.681,9.8Z",
    transform: "translate(344.291 410.527)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Board",
    transform: "translate(316.249 204.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(107.608 130.884)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 4.192,
    height: 53.092,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 234.81,
    height: 147.742,
    rx: 5.096,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(106.122 217.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 7.165,
    height: 63.287,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(99.927 272.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M-163,599.4h-19.577v-2.1a7.6,7.6,0,0,1,7.6-7.6h4.383a7.6,7.6,0,0,1,7.6,7.6Z",
    transform: "translate(182.575 -589.696)",
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(107.142 183.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 5.125,
    height: 34.056,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(6.321 7.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 221.623,
    height: 134.829,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(94.352 67.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 11.657,
    height: 45.867,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(112.273 55.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 11.657,
    height: 57.867,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(130.194 53.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 11.657,
    height: 59.912,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(148.115 77.033)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 11.657,
    height: 36.264,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(166.035 46.285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 11.657,
    height: 67.012,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(183.956 34.357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 11.657,
    height: 78.94,
    transform: "translate(0)",
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(83.072 12.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M-74.773,379.328H-86.651l1.394,2.415-35.147,21h-31.153l-44.679,22.927,2.87,5.594,43.327-22.234h31.37l36.555-21.843,1.4,2.426Z",
    transform: "translate(196.236 -379.328)",
    fill: "#0555e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(16.8 20.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 25.533,
    height: 8.677,
    rx: 3.516,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(16.8 33.383)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 60.463,
    height: 8.677,
    rx: 3.516,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(16.8 46.285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 51.371,
    height: 8.677,
    rx: 3.516,
    fill: "#eef0f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Model_4",
    "data-name": "Model 4",
    transform: "translate(281.263 248.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(36.354 49.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M-251.416,458.833l-3.507-14.022-7.534,2.81,2.814,12.742,4,4.275Z",
    transform: "translate(262.457 -444.811)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0 112.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M-290.634,495.518s-2.576,12.941-.438,20.939,17.24,31.159,17.071,32.964-1.207,15.165,8.049,16.362l3.114-3.869-2.173-18.668s-10.274-15.885-11.268-21.694,1.75-14.439,1.75-14.439S-286.857,494.9-290.634,495.518Z",
    transform: "translate(291.921 -495.496)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(35.599 25.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M-251.281,426.311a6.11,6.11,0,0,1,4.485,6.713c-.55,5.474,2.458,6.4,2.044,11.04s-.062,20.162-11.178,6.753S-264.937,421.6-251.281,426.311Z",
    transform: "translate(263.068 -425.462)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M-246.706,431.435c-.94,1.742-1.824,4.009-1.891,9.609-.125,10.589-3.483,21.931-11.224,18.289-1.4-.691-4.117-5.889-5.387-7.626s-9.43-10.107-8.587-19.193a7.563,7.563,0,0,1,.27-1.2,4.486,4.486,0,0,1-.052-.6h0s-2.543-10.148,5.9-10.682c0,0-1.15-4.078,6.513-4.951,0,0-2.074,1.34-2.074,2.083,0,0,1.9-1.716,6.1-1.539a10.252,10.252,0,0,1,3.114.607c1.008-.932,3.83-2.185,4.547-3.123a1.13,1.13,0,0,1,1.872.048c1.565,2.26,2.559,3.393,2.975,7.334C-244.636,420.489-244.643,428.115-246.706,431.435Z",
    transform: "translate(296.125 -402.769)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(21.378 134.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M-274.594,522.39s3.906,52.438,4.057,56.9,3.472,50.786,3.472,50.786l30.746,1.716a378.461,378.461,0,0,0,6.088-49.071c.687-13.533.545-54.775.545-54.775l-25.561-13.905Z",
    transform: "translate(274.594 -514.041)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(30.137 249.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M-258.475,606.637s-1.634,7.9-1.152,8.35,2.978,2.925,2.978,2.925L-257.8,621.8l-6.631.9-3.062-6.369v-9.161Z",
    transform: "translate(267.495 -606.637)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(38.027 157.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M-258.276,626.531c0-.169.015-17.028.6-35.518s-3.381-58.482-3.421-58.884",
    transform: "translate(261.1 -532.129)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M-258.114,579.861",
    transform: "translate(261.798 -520.969)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(24.042 246.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M-255.5,606.4l-.19,3.22a1.341,1.341,0,0,1-1.37,1.261l-13.987-.323a1.34,1.34,0,0,1-1.309-1.31l-.084-3.779a1.339,1.339,0,0,1,1.423-1.367l14.262.881A1.34,1.34,0,0,1-255.5,606.4Z",
    transform: "translate(272.435 -604.094)",
    fill: "#0555e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(47.124 252.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M-253.727,610.012v9.245l3.083,6.179.125.249,6.945-.9,1.208-4.7s-2.147-1.408-2.925-2.014c-.081-.063-.147-.117-.195-.16-.259-.236.068-2.457.447-4.559.357-1.988.761-3.869.761-3.869Z",
    transform: "translate(253.727 -609.478)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(83.439 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M-200.829,430.787c-1.476,3.278-7.526,15.6-10.913,23.441s-12.428,7.55-12.428,7.55l3.213,22.019s4.7-1,13.561-5.956a11.477,11.477,0,0,0,3.805-4.158,45.428,45.428,0,0,0,3.453-7.171c1.156-2.914,2.152-5.892,3.077-8.887.954-3.083,1.829-6.191,2.672-9.305.761-2.807,1.493-5.621,2.243-8.431.548-2.053,1.061-4.118,1.747-6.131a14.291,14.291,0,0,1,2.946-4.964,2.687,2.687,0,0,1,1.962-1.041,4.65,4.65,0,0,0,.848.2c.751-.086,1.469-1.024,2-1.492q3.224-2.9,6.474-5.78l.755-.679a1.242,1.242,0,0,0,.088-1.764,1.235,1.235,0,0,0-1.757-.1l.373-.343.049-.047a1.748,1.748,0,0,0,.13-2.489,1.759,1.759,0,0,0-2.49-.154l.169-.158a1.765,1.765,0,0,0,.134-2.489,1.771,1.771,0,0,0-2.495-.159l-.267.237.037-.039.157-.185,4.508-5.261a1.4,1.4,0,0,0-.086-1.912,1.4,1.4,0,0,0-1.935-.017l-5.64,5.3-.485.437-1.6,1.423c-1.068.951-3.192,3.054-3.583,3.442l2.378-2.453a.221.221,0,0,0-.079-.365c-1.257-.474-5.87-1.674-5.666,6.09,0,0,.02.37-.076.479s-.981,1.346-1.993,2.753a72.176,72.176,0,0,0-5.294,8.555",
    transform: "translate(224.323 -404.613)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M-221.038,483.978l-.02-.138-3.236-22.173.157,0c.089.006,8.992.195,12.3-7.472,2.258-5.225,5.679-12.4,8.179-17.646,1.252-2.628,2.242-4.7,2.734-5.8l0-.007a73.033,73.033,0,0,1,5.3-8.571l.59-.819c.85-1.183,1.335-1.857,1.413-1.945a.9.9,0,0,0,.043-.384c-.079-3.023.556-5.035,1.891-5.985a4.362,4.362,0,0,1,3.952-.234.341.341,0,0,1,.22.249l0,.01c.345-.327.668-.627.929-.859l2.08-1.859,5.639-5.3a1.529,1.529,0,0,1,2.115.019,1.534,1.534,0,0,1,.094,2.093l-4.04,4.716a1.922,1.922,0,0,1,2.1.519,1.886,1.886,0,0,1,.48,1.373,1.884,1.884,0,0,1-.264.864,1.926,1.926,0,0,1,.642-.075,1.9,1.9,0,0,1,1.328.639,1.889,1.889,0,0,1,.489,1.389,1.834,1.834,0,0,1-.473,1.131,1.381,1.381,0,0,1,1.189.452,1.367,1.367,0,0,1-.1,1.952l-.755.677c-2.529,2.247-4.586,4.084-6.474,5.78-.13.112-.268.252-.415.4a3.266,3.266,0,0,1-1.662,1.125,1.466,1.466,0,0,1-.571-.115,1.829,1.829,0,0,0-.307-.085,2.572,2.572,0,0,0-1.853,1.006,14.056,14.056,0,0,0-2.914,4.912c-.569,1.667-1.025,3.4-1.468,5.073l-.278,1.049q-.435,1.632-.865,3.265c-.455,1.722-.911,3.446-1.377,5.166-.993,3.664-1.843,6.622-2.675,9.312-1.08,3.493-2.058,6.32-3.08,8.9a46.2,46.2,0,0,1-3.465,7.191,11.628,11.628,0,0,1-3.853,4.2c-8.775,4.907-13.55,5.958-13.6,5.969Zm-2.953-22.043,3.171,21.726c.834-.207,5.472-1.483,13.388-5.909a11.388,11.388,0,0,0,3.757-4.113,46.027,46.027,0,0,0,3.445-7.15c1.019-2.57,2-5.391,3.072-8.877.832-2.686,1.68-5.641,2.672-9.3.466-1.72.922-3.442,1.377-5.165q.431-1.634.865-3.266l.278-1.048c.443-1.679.9-3.416,1.473-5.091a14.324,14.324,0,0,1,2.972-5.009,2.786,2.786,0,0,1,2.072-1.085,1.914,1.914,0,0,1,.362.1,1.362,1.362,0,0,0,.46.1,3.167,3.167,0,0,0,1.505-1.049c.151-.152.294-.295.426-.411,1.888-1.7,3.944-3.532,6.474-5.779l.754-.679a1.107,1.107,0,0,0,.078-1.581,1.1,1.1,0,0,0-1.571-.085l-.176-.193h0l.418-.387a1.575,1.575,0,0,0,.545-1.107,1.628,1.628,0,0,0-.422-1.2,1.644,1.644,0,0,0-1.147-.553,1.585,1.585,0,0,0-1.156.407l-.178-.192.169-.158a1.606,1.606,0,0,0,.539-1.121,1.613,1.613,0,0,0-.413-1.183,1.644,1.644,0,0,0-2.31-.148l-.266.236-.184-.186.19-.22,4.508-5.263a1.269,1.269,0,0,0-.078-1.732,1.265,1.265,0,0,0-1.753-.016l-6.128,5.74-1.6,1.424c-1.023.912-3,2.861-3.579,3.437l-.186-.184,2.379-2.452a.1.1,0,0,0,.026-.09.079.079,0,0,0-.054-.06,4.1,4.1,0,0,0-3.71.2c-1.26.9-1.858,2.834-1.782,5.761a.96.96,0,0,1-.109.569c-.073.081-.686.935-1.4,1.922l-.589.82a72.552,72.552,0,0,0-5.283,8.537c-.494,1.1-1.482,3.171-2.735,5.8-2.5,5.24-5.919,12.416-8.175,17.637C-214.731,461.567-222.769,461.924-223.991,461.935Z",
    transform: "translate(224.294 -404.638)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(39.439 247.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M-237,607.59l-.284,3.213a1.339,1.339,0,0,1-1.347,1.223l-19.917-.189a1.34,1.34,0,0,1-1.326-1.31l-.085-3.8a1.34,1.34,0,0,1,1.39-1.37l20.285.772A1.341,1.341,0,0,1-237,607.59Z",
    transform: "translate(259.956 -605.359)",
    fill: "#0555e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(39.439 247.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M-259.868,610.587l0-.061-.085-3.8a1.34,1.34,0,0,1,1.39-1.37l.273.01",
    transform: "translate(259.956 -605.359)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(1.313 57.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M-207.078,450.893s-4.875.865-12.985,2.154c-8.791,1.4-42.49-2.844-56.995,11.626-4.872,4.718-12.935,29.547-13.8,41.275,0,0,8.249,8.455,16.046,12.553l2.016-3.908s.418,11.747,2.323,26.863c0,0,18.157,7.556,44.588,1.255,0,0-3.627-50.632-.413-58.065s22.226-11.616,22.226-11.616Z",
    transform: "translate(290.857 -450.893)",
    fill: "#0555e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(18.556 98.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M-276.881,484.357c0,3.069.819,22.186.829,22.379",
    transform: "translate(276.881 -484.357)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(28.079 256.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M-259.162,612.515c-.886,1.321-4.1,4.911-8.1,1.8-.17-.133-.387-.021-.436.236-.274,1.476-.659,3.434-.969,4.981a26.2,26.2,0,0,0-.5,5.2h0l23.639-.142h0a3.349,3.349,0,0,0-2.176-3.423,15.46,15.46,0,0,1-10.954-8.581C-258.766,612.344-259.017,612.3-259.162,612.515Z",
    transform: "translate(269.163 -612.377)",
    fill: "#f6f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(17.227 1.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M-244.846,613.915c-.913,1.252-4.249,4.664-8.5,1.822a.3.3,0,0,0-.454.228c-.267,1.384-.645,3.223-.948,4.676a21.775,21.775,0,0,0-.45,4.877h0l24.88-.532h0a3.151,3.151,0,0,0-2.341-3.165c-3.242-.6-8.8-2.428-11.655-7.845A.3.3,0,0,0-244.846,613.915Z",
    transform: "translate(255.201 -613.782)",
    fill: "#f6f7f7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin2);
export default __webpack_public_path__ + "static/media/login-2.2d9f72c9b03d262d5d6b2f90603f298f.svg";
export { ForwardRef as ReactComponent };